import {
  Button,
  FormControl,
  HStack,
  Input,
  Stack,
  Text,
} from '@chakra-ui/react'

type StudyHoursInputProps = {
  accentColor: string
  label: string
  value: string
  onChange: (value: string) => void
}

export const StudyHoursInput = ({
  accentColor,
  label,
  value,
  onChange,
}: StudyHoursInputProps) => {
  const valueAsNumber = Number(value)
  const increment = () =>
    onChange(String((Number.isFinite(valueAsNumber) ? valueAsNumber : 0) + 1))
  const decrement = () => onChange(String(Math.max(0, valueAsNumber - 1)))

  return (
    <FormControl>
      <HStack
        align="stretch"
        border="1px solid"
        borderColor={`${accentColor}.300`}
        borderRadius="xl"
        h="64px"
        overflow="hidden"
        spacing={0}
      >
        <Input
          aria-label={`${label} hours`}
          border={0}
          borderRadius={0}
          fontSize="2xl"
          fontWeight="bold"
          h="full"
          lineHeight="1"
          min={0}
          py={0}
          px={6}
          required
          type="number"
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        <Stack
          borderLeft="1px solid"
          borderColor={`${accentColor}.200`}
          h="full"
          spacing={0}
          w="84px"
        >
          <Button
            aria-label={`Increase ${label.toLowerCase()} hours`}
            borderRadius={0}
            color={`${accentColor}.600`}
            flex={1}
            fontSize="2xl"
            minH="unset"
            onClick={increment}
            variant="ghost"
          >
            +
          </Button>
          <Button
            aria-label={`Decrease ${label.toLowerCase()} hours`}
            borderRadius={0}
            borderTop="1px solid"
            borderColor={`${accentColor}.200`}
            color={`${accentColor}.600`}
            flex={1}
            fontSize="2xl"
            isDisabled={valueAsNumber <= 0}
            minH="unset"
            onClick={decrement}
            variant="ghost"
          >
            −
          </Button>
        </Stack>
        <Text
          alignItems="center"
          alignSelf="stretch"
          bg={`${accentColor}.50`}
          display="flex"
          fontSize="lg"
          h="full"
          justifyContent="center"
          px={6}
        >
          hours
        </Text>
      </HStack>
    </FormControl>
  )
}
